import styled from '../../../../../../styles/styledComponents/themeComponents';

export const ProductWidgetPreviewModalButton = styled.div`
  padding: 0 15px;
  width: 100%;
  margin-top: 20px;

  button {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: -0.1px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border: solid 0.5px #495057;
    cursor: pointer;
    background: none;
    width: 100%;

    .require-info {
      color: #f03e3e;
    }
  }
`;
